import type { z } from 'zod';

import type {
  AiReviewSettingsResponseSchema,
  AutoApproveFilterSchema,
  DocumentationLinkSchema,
  GlobPatternSchema,
  LabelPatternSchema,
  SensitivitySchema,
  YamlSettingOriginSchema,
} from './schema';

import { AiReviewSettingsUpdateSchema as BaseUpdateSchema } from './schema';

export type SensitivityLevel = z.infer<typeof SensitivitySchema>;

export type GlobPattern = z.infer<typeof GlobPatternSchema>;
export type LabelPattern = z.infer<typeof LabelPatternSchema>;
export type DocumentationLink = z.infer<typeof DocumentationLinkSchema>;
export type AutoApproveFilter = z.infer<typeof AutoApproveFilterSchema>;

export type IgnorePatterns = Array<GlobPattern> | null;
export type IncludePatterns = Array<GlobPattern> | null;
export type AutoApproveExcludePatterns = Array<GlobPattern> | null;
export type AutoApproveIncludePatterns = Array<GlobPattern> | null;
export type AutoApproveFilters = Array<AutoApproveFilter> | null;
/** The auto-fix loop's automatic-mode gates, stored in the same row shape as the auto-approval filters. */
export type AutoFixLoopFilters = Array<AutoApproveFilter> | null;
/** Which pull requests Verify films, stored in the same row shape as the auto-approval filters. */
export type VerifyFilters = Array<AutoApproveFilter> | null;
export type BranchPatterns = Array<GlobPattern> | null;
export type BaseBranchPatterns = Array<GlobPattern> | null;
export type LabelPatterns = Array<LabelPattern> | null;
export type TitlePatterns = Array<GlobPattern> | null;

export type AIReviewSettings = z.infer<typeof AiReviewSettingsResponseSchema>;
export type AIReviewSettingField = Exclude<
  keyof AIReviewSettings,
  'installationId' | 'repositoryId' | 'yamlSettingOrigins'
>;
export type YamlSettingOrigin = z.infer<typeof YamlSettingOriginSchema>;
export type AiReviewSettingsUpdateInput = z.infer<typeof BaseUpdateSchema>;

export const AIReviewSettingsUpdateSchema = BaseUpdateSchema;
